enum ClientPortfolioSortBy {
  Name = 'name',
  SystemSize = 'systemSize',
}

export default ClientPortfolioSortBy;
